export default __webpack_public_path__ + "f517c779705b6f127f4a859410bfe8ba.wav";